import {Button, Modal} from "react-bootstrap";
import {
  generateForm,
  generateInitValues,
  generateValidationSchema,
} from "../../../../utils/AppFunction";
import React, {Dispatch, SetStateAction, useContext, useEffect, useState} from "react";
import {AppContext} from "../../../../appContext/AppContext";
import {XayDungKeHoachContext} from "../CoSoKBCB";
import {Formik, Form} from "formik";
import {addPhieuKeHoach, updatePhieuKeHoach} from "../services/services";
import {CODE, TYPE_WH} from "../../../../utils/Constant";
import {toast} from "react-toastify";
import WfButton from "../../../../workflows/components/WfButton";
import {IconButtonSave} from "../../../../component/IconSvg";
import {formatDateDTO} from "../../../../utils/FormatUtils";
import {TypeKeHoach} from "../models/KeHoachModel";
import ModelHeader from "../../../../component/ModelHeader";
import DynamicComponent from "../../../../component/GenerateDynamicComponent";
import GenerateFormComponent from "../../../../component/generate-form/GenerateFormHTMLNoValid";
import FormThemVatTu from "./FormThemVatTu";
import CustomTabMenu from "../../../../component/CustomTabMenu";
import FormThemNhanLuc from "./FormThemNhanLuc";
import NhanLuc from "./NhanLuc";
import {TYPE_KB_CB} from "../constants/constansKeHoach";
import YCTrangThietBi from "./YCTrangThietBi";
import DuDoanKinhPhi from "./DuDoanKinhPhi";

interface Props {
  show: boolean;
  onHide: () => void;
  initialValues: any;
  setInitialValues: Dispatch<SetStateAction<any>>
  warehouseId?: any;
  type: TypeKeHoach;
}

const DialogThongTinDot = (props: Props) => {
  const {show, onHide, warehouseId, setInitialValues, initialValues, type} = props;
  const {setIsLoading} = useContext(AppContext);
  const {dsKeHoach, setDsKeHoach, detailPhieuKeHoach, setDetailPhieuKeHoach} = useContext(XayDungKeHoachContext);
  const [isView, setIsView] = useState<boolean>(false);
  const [listJsonGenerate, setListJsonGenerate] = useState<any>([]);
  const [listJsonGenerateVT, setListJsonGenerateVT] = useState<any>([]);
  const [initialValuesFormThemVT, setInitialValuesFormThemVT] = useState<any>({});
  const [indexRowEdit, setIndexRowEdit] = useState<number | null>(null);

  const handleAddItem = async (values: any) => {
    const dataItem = values.keHoach || {};
    if (!dataItem?.content || !dataItem?.receivingHospital) return;

    const addItem = {
      content: dataItem?.content,
      receivingHospital: dataItem?.receivingHospital,
      receivingHospitalCode: dataItem?.receivingHospitalCode,
      receivingHospitalId: dataItem?.receivingHospitalId,
      receivingHospitalName: dataItem?.receivingHospitalName,
    }

    let newLstItem = [...dsKeHoach];
    if (indexRowEdit === null) {
      newLstItem = [...newLstItem, {...addItem}];
    } else {
      newLstItem[indexRowEdit] = {...addItem};
    }
    setIndexRowEdit(null);
    const updateValueForm = {
      ...dataItem,
      content: "",
      receivingHospital: "",
      receivingHospitalCode: "",
      receivingHospitalId: "",
      receivingHospitalName: ""
    }
    setInitialValuesFormThemVT(updateValueForm);
    setDsKeHoach(newLstItem);
  };

  const handleFormSubmit = async (values: any) => {
    if (!dsKeHoach?.length) {
      toast.warning('Chưa có nội dung CĐT');
      return;
    }
    const dataSubmit = {
      slipDto: {
        ...initialValuesFormThemVT,
        type: TYPE_WH.IMPORT,
        doCreation: values?.keHoach?.id ? formatDateDTO(values?.keHoach?.doCreation) : formatDateDTO(new Date()),
        listOfInstructions: [...(dsKeHoach || [])].map(item => {
          return (
            {
              ...item,
              id: item?.id || null,
            }
          )
        })
      },
      trackerCode: type.trackerCode,
      termModelType: type?.formVatTu,
    };

    try {
      setIsLoading(true);
      const id = values.keHoach?.id;
      const {data} = id ? await updatePhieuKeHoach(id, dataSubmit) : await addPhieuKeHoach(dataSubmit);
      if (CODE.SUCCESS === data?.code) {
        setIsView(true);
        setInitialValues && setInitialValues(data?.data);
        setDetailPhieuKeHoach({
          ...data?.data,
          statusId: detailPhieuKeHoach.statusId,
        });
        toast.success(((id) ? "Cập nhật" : "Thêm") + " kế hoạch thành công");
      } else {
        let errorMesage = data?.data?.[0]?.message || "Xảy ra lỗi, vui lòng thử lại!";
        toast.warning(errorMesage);
        setIsLoading(false);
      }
    } catch (error) {
      setIsLoading(false);
      toast.warning("Xảy ra lỗi, vui lòng thử lại!");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    initialValues?.keHoach?.id && setDsKeHoach(initialValues?.keHoach?.listOfInstructions);
  }, [initialValues?.keHoach?.id]);

  useEffect(() => {
    updateForm();
    updateFormVatTu();
  }, []);

  const updateFormVatTu = async () => {
    if (!type?.formVatTu) return;
    const data = await generateForm(type?.formVatTu, setIsLoading);
    setListJsonGenerateVT(data || []);
    setInitialValuesFormThemVT(generateInitValues(data));
  };

  const updateForm = async () => {
    if (!type?.formThongTinChung) return;
    const data = await generateForm(type?.formThongTinChung, setIsLoading);
    setListJsonGenerate(data || []);
  };

  const handler = (data: any) => {
    setInitialValuesFormThemVT({
      ...initialValuesFormThemVT,
      ...data,
      isFirstChange: true,
    });
  };
  return (
    <Modal
      centered
      show={show}
      // onHide={onHide}
      size="xl"
      fullscreen
      className="page-full spaces h-calc-vh-50 dialog-coso-kb-cb"
    >
      <Formik
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        initialValues={initialValues}
        validationSchema={generateValidationSchema(listJsonGenerate, type?.formThongTinChung || "")}
        onSubmit={handleFormSubmit}
      >
        {({values, touched, errors, setValues, handleChange, handleSubmit, setFieldValue}) => (
          <>
            <Form onSubmit={handleSubmit}>
              <ModelHeader onHide={onHide} title={`Quá trình chuyển giao`}/>
              <Modal.Body className="spaces p-0 bg-white">
                <CustomTabMenu
                  danhsachTabs={[
                    {
                      eventKey: "0",
                      title: "Nhân lực",
                      component: <NhanLuc
                        dataNhanLuc={{
                        tuyenTren: [],
                        tuyenDuoi: []
                      }} setDataNhanLuc={function (value: any): void {
                        throw new Error("Function not implemented.");
                      }} isView={false}                      />,
                    },
                    {
                      eventKey: "1",
                      title: "Yêu cầu trang thiết bị",
                      component: <YCTrangThietBi
                        isView
                        initialValues={undefined}
                        setInitialValues={function (value: any): void {
                          throw new Error("Function not implemented.");
                        }} dataTrangThietBi={[]}
                        setDataTrangThietBi={function (value: SetStateAction<any[]>): void {
                          throw new Error("Function not implemented.");
                        }}                      />,
                    },
                    {
                      eventKey: "2",
                      title: "Dự đoán",
                      component: <DuDoanKinhPhi
                        isView
                        initialValues={undefined}
                        setInitialValues={function (value: any): void {
                          throw new Error("Function not implemented.");
                        }} type={TYPE_KB_CB.NOI_DUNG_CHUYEN_GIAO} dataKinhPhi={undefined}
                        setDataKinhPhi={function (value: any): void {
                          throw new Error("Function not implemented.");
                        }}                      />,
                    },
                  ]}
                />
              </Modal.Body>
              <div className="bottom-button d-flex justify-content-start w-100 bg-white spaces py-6 pl-5">
                {(values.keHoach?.id || detailPhieuKeHoach?.id) && !detailPhieuKeHoach?.isView && (
                  <WfButton
                    additionalFunc={(data: any) => {
                      setDetailPhieuKeHoach({
                        ...detailPhieuKeHoach,
                        status: data?.currCode,
                        statusCode: data?.currCode,
                        statusId: data?.currId,
                      })
                    }}
                    // handleClick={(data: any) => {
                    //   data.code === "allowed-edit" && setIsView(false);
                    // }}
                    tracker={type.trackerCode}
                    objectId={values.keHoach?.id || detailPhieuKeHoach?.id}
                  />
                )}
                {!isView &&
                    <Button type="submit" className="btn btn-fill min-w-120px spaces mx-3">
                        <IconButtonSave/> Lưu
                    </Button>
                }
              </div>
            </Form>
          </>
        )}
      </Formik>
    </Modal>
  );
};

export default DialogThongTinDot;
